import { ShieldAlert, ShieldCheck, ShieldX, Gauge, FileText, AlertTriangle, GitMerge, ListChecks, Eye } from "lucide-react";
import { labelNiveau } from "@/lib/criticite";

const STATUT_META = {
  compatible: { cls: "ok", Icon: ShieldCheck, txt: "Compatible" },
  sous_conditions: { cls: "warn", Icon: ShieldAlert, txt: "Compatible sous conditions" },
  bloquant: { cls: "stop", Icon: ShieldX, txt: "Bloquant" },
};

function Section({ icon: Icon, title, items, empty, mono }) {
  return (
    <div className="vitem" style={{ paddingTop: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 7, fontFamily: "'Space Mono'", fontSize: ".62rem", textTransform: "uppercase", color: "var(--text-muted)", letterSpacing: ".05em" }}>
        <Icon size={13} />{title}
      </div>
      {items && items.length ? (
        <ul style={{ margin: "6px 0 0", paddingLeft: 16, fontSize: ".82rem", lineHeight: 1.5 }}>
          {items.map((x, i) => <li key={i} className={mono ? "mono" : ""}>{x}</li>)}
        </ul>
      ) : <div style={{ fontSize: ".8rem", color: "var(--text-muted)", marginTop: 4 }}>{empty}</div>}
    </div>
  );
}

export default function OperationAnalysisPanel({ analysis }) {
  if (!analysis) return null;
  const { criticite, statut, permisRequis, risques, documentsManquants, vigilance, conflits, actions } = analysis;
  const meta = STATUT_META[statut] || STATUT_META.compatible;

  return (
    <div className={`verdict ${meta.cls}`} aria-live="polite" data-testid="operation-analysis">
      <div className="verdict-head"><meta.Icon size={22} strokeWidth={2.2} />{meta.txt}</div>
      {meta.cls === "stop" && <div className="hatch" />}
      <div className="verdict-body">
        <div className="vitem" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingTop: 4 }}>
          <span style={{ display: "flex", alignItems: "center", gap: 7, fontFamily: "'Space Mono'", fontSize: ".62rem", textTransform: "uppercase", color: "var(--text-muted)" }}>
            <Gauge size={13} />Criticité calculée
          </span>
          <span className={`badge b-${criticite.niveau}`} data-testid="analysis-criticite">{labelNiveau(criticite.niveau)} · {criticite.score}</span>
        </div>
        <div style={{ fontSize: ".8rem", padding: "6px 0", color: "var(--text-main)" }}>{criticite.justification}</div>
        {criticite.facteurs.length > 0 && (
          <div className="chips" style={{ marginBottom: 4 }}>
            {criticite.facteurs.slice(0, 6).map((f, i) => (
              <span key={i} className="tag" title={`+${f.poids}`}>{f.label} <b>+{f.poids}</b></span>
            ))}
          </div>
        )}
        <Section icon={FileText} title="Permis probablement requis" items={permisRequis.map((p) => p.label)} empty="Aucun permis identifié pour l'instant." />
        <Section icon={AlertTriangle} title="Risques détectés" items={risques} empty="Aucun risque détecté." />
        <Section icon={FileText} title="Documents manquants" items={documentsManquants} empty="Aucun document en attente." />
        <Section icon={GitMerge} title="Conflits potentiels" items={conflits} empty="Aucun conflit de coactivité détecté." />
        <Section icon={Eye} title="Points de vigilance" items={vigilance} empty="Aucun point de vigilance particulier." />
        <Section icon={ListChecks} title="Actions à prévoir" items={actions} empty="Aucune action à prévoir." />
      </div>
    </div>
  );
}
